<template>
  <v-card flat>
    <v-card-title class="header-title ml-3"> Approval Entries </v-card-title>
    <v-card-text>
      <v-timeline dense>
        <v-timeline-item
          v-for="(item, i) in filteredApprovalEntries"
          :key="i"
          small
          fill-dot
          :color="getColor(item.status).icon_color"
          :icon="getColor(item.status).icon"
        >
          <v-row v-if="item.status !== 'Canceled'">
            <v-col cols="4">
              <v-list-item>
                <v-list-item-avatar
                  :color="getColor(item.status).icon_color"
                  style="color: rgb(0, 68, 139); padding: 1rem"
                  size="50"
                >
                  {{ getEmployeeNameAbbreviation(item.approverName) }}
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="view-page font-weight-bold">
                    {{ item.approverName }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="">
                    {{ item.approverEmail }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="4">
              <div class="d-flex justify-start">
                <v-icon>schedule</v-icon>
                <strong class="view-page">{{
                  getEntryDateFormat(item.lastDateTimeModified)
                }}</strong>
              </div>
              <v-divider />
              <div class="d-flex justify-start">
                <div class="">
                  <h1 class="view-page">Status:</h1>
                </div>
                <v-chip
                  label
                  class="mx-1 my-1"
                  :color="getColor(item.status).icon_color"
                  x-small
                  ><span class="view-page">{{ item.status }}</span>
                </v-chip>
              </div>
            </v-col>
            <v-col cols="4">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="view-page font-weight-bold">
                    Comment
                  </v-list-item-title>
                  <v-card flat class="mt-1 text--secondary">
                    {{ getComment(item.approvalComments) }}
                  </v-card>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-timeline-item>
      </v-timeline>
    </v-card-text>
  </v-card>
</template>
<script>
import helper from "@kinetics254/cassandra-base/utilities/helpers/helper";
export default {
  name: "ApprovalEntries",
  props: {
    approvalEntries: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    filteredApprovalEntries() {
      return this.approvalEntries.filter((item) => item.status !== "Canceled");
    },
  },

  methods: {
    getEmployeeNameAbbreviation(name) {
      const parts = name.trim().split(/\s+/);

      if (parts.length < 2) return parts[0]?.charAt(0).toUpperCase() || "";

      return (parts[0][0] + parts[1][0]).toUpperCase();
    },

    getColor(status) {
      return helper.getColor(status);
    },
    getEntryDateFormat(date) {
      return helper.getEntryDateFormat(date);
    },
    getComment(comment) {
      return comment[0] ? comment[0].comment : "";
    },
  },
};
</script>
<style scoped>
@import url("../styles.css");
</style>
